// This module is less important now that Babel is transpiling the classes for ui-common.
// when babel transpiles, the classes loses the instance of check.
// It may be salvagable.  --pbc 9.9.2021

class FormSubmissionError extends Error implements CMxCommonApp.CMxError {
  response: Response;
  errors: CMxCommonApp.FormErrors;

  constructor(
    message: string,
    response: Response,
    errors: CMxCommonApp.FormErrors
  ) {
    super(message);
    this.response = response;
    this.errors = errors;
  }
}

class UnauthenticatedError extends Error {}

class ServerError extends Error {}

class PageNotFoundError extends Error {
  errors: CMxCommonApp.FormErrors;

  constructor(message: string) {
    super(message);

    const errors: CMxCommonApp.FormErrors = {
      status: 'PAGE NOT FOUND',
      message,
      errors: [message],
      fieldErrors: {}
    };

    this.errors = errors;
  }
}

class BadRequestError extends FormSubmissionError {}

const getFieldErrorMessage = (
  formErrors: CMxCommonApp.FormErrors,
  keys: string[]
) => {
  const { fieldErrors } = formErrors;
  let fieldErrorMessage = '';

  for (const fieldErrorKey in fieldErrors) {
    if (keys.some(key => key === fieldErrorKey)) {
      fieldErrorMessage =
        fieldErrorMessage + fieldErrors[fieldErrorKey].join('. ');
    }
  }
  return fieldErrorMessage;
};

export {
  FormSubmissionError,
  UnauthenticatedError,
  ServerError,
  PageNotFoundError,
  getFieldErrorMessage,
  BadRequestError
};
